import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ImageConfiguration } from '../models/image-configuration';

@Injectable({
  providedIn: 'root'
})

export class BaseService<T> {
  protected apiUrl: string = environment.apiRoot;

  constructor(protected http: HttpClient) { }

  getAll(url: string, context?: HttpContext): Observable<T[]> {
    return this.http.get<T[]>(`${this.apiUrl + url}`, { context });
  }

  getById(url: string, id?: number): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}${url}${id == null ? '' : `/${id}`}`);
  }

  getUserImage(url: string, image: string): Observable<T> {
    return this.http.get<T>(`${this.apiUrl + url}/${image}`);
  }

  // create(url:string, item: any): Observable<T> {
  //   return this.http.post<T>(`${this.apiUrl + url}`, item);
  // }

  create(url: string, item: any): Observable<any> {
    return this.http.post<T>(`${this.apiUrl + url}`, item);
  }

  update(url: string, id: number, item: any): Observable<T> {
    return this.http.put<T>(`${this.apiUrl + url}/${id}`, item);
  }

  delete(url: string, id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl + url}/${id}`);
  }

  getPlace(url: string, searchText: string): Observable<any> {
    return this.http.get<T>(`${this.apiUrl + url}/${searchText}/Bliss`);
  }

  uploadBusinessImage(url: string, image: FormData, branchId: number, imageType: number): Observable<T> {
    return this.http.post<T>(`${this.apiUrl + url}/${branchId}/ImageType/${imageType}`, image);
  }

  updateBusinessImage(url: string, image: FormData, branchId: number, imageType: number, recordId: number): Observable<T> {
    return this.http.post<T>(`${this.apiUrl + url}/${branchId}/recordId/${recordId}/ImageType/${imageType}`,image);
  }

  updatePreRegisterBusinessImage(url: string, image: FormData, preRegisterImageId: number, batchId: number): Observable<T> {
    return this.http.post<T>(`${this.apiUrl + url}/${preRegisterImageId}/batchId/${batchId}`, image);
  }

  getDataFromJson(url: string): Observable<T> {
    return this.http.get<T>(`${url}`);
  }

  downloadCSV(url: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl + url}`, { responseType: 'blob' })
  }
}
